<h4 nz-typography>Buttons</h4>
<button nz-button nzType="primary">Primary Button</button>
<button nz-button nzType="default">Default Button</button>
<button nz-button nzType="text">Text Button</button>
